/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
/**
=========================================================
* Material Dashboard 2  React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useMemo, useState } from "react";

// porp-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-chartjs-2 components
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";
import Menu from "@mui/material/Menu";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import IconButton from "@mui/material/IconButton";
import NotificationItem from "examples/Items/NotificationItem";
// ReportsBarChart configurations
import configs from "examples/Charts/BarCharts/ReportsBarChart/configs";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import NativeSelect from "@mui/material/NativeSelect";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function ReportsBarChart({ color, title, description, chart, filtrarAnio }) {
  const { data, options } = configs(chart.labels || [], chart.datasets || {});
  const [age, setAge] = useState("");
  const [openMenu, setOpenMenu] = useState(false);
  const handleChange = (event) => {
    setAge(event.target.value);
  };
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);

  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
    >
      <NotificationItem
        onClick={() => {
          handleCloseMenu;
          filtrarAnio("");
        }}
        icon={<Icon>calendar_month</Icon>}
        title="Mostrar todos"
      />
      <NotificationItem
        onClick={() => {
          handleCloseMenu;
          filtrarAnio("2025");
        }}
        icon={<Icon>calendar_month</Icon>}
        title="2025"
      />
      <NotificationItem
        onClick={() => {
          handleCloseMenu;
          filtrarAnio("2024");
        }}
        icon={<Icon>calendar_month</Icon>}
        title="2024"
      />
      <NotificationItem
        onClick={() => {
          handleCloseMenu;
          filtrarAnio("2025");
        }}
        icon={<Icon>calendar_month</Icon>}
        title="2023"
      />
      <NotificationItem
        onClick={() => {
          handleCloseMenu;
          filtrarAnio("2022");
        }}
        icon={<Icon>calendar_month</Icon>}
        title="2022"
      />
      <NotificationItem
        onClick={() => {
          handleCloseMenu;
          filtrarAnio("2021");
        }}
        icon={<Icon>calendar_month</Icon>}
        title="2021"
      />
      <NotificationItem
        onClick={() => {
          handleCloseMenu;
          filtrarAnio("2020");
        }}
        icon={<Icon>calendar_month</Icon>}
        title="2020"
      />
    </Menu>
  );

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox padding="1rem">
        {useMemo(
          () => (
            <MDBox
              variant="gradient"
              bgColor={color}
              borderRadius="lg"
              coloredShadow={color}
              py={2}
              pr={0.5}
              mt={-5}
              height="20rem"
            >
              <Bar data={data} options={options} redraw />
            </MDBox>
          ),
          [color, chart]
        )}
        <MDBox pt={3} pb={1} px={1}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={8}>
              <MDBox mb={1.5}>
                <MDTypography omponent="div" variant="button" color="text" fontWeight="light">
                  {title}
                </MDTypography>
              </MDBox>
            </Grid>

            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={1.5} textAlign="right">
                {/*<IconButton
                  size="medium"
                  color="primary"
                  aria-controls="notification-menu"
                  aria-haspopup="true"
                  variant="contained"
                  onClick={() => {}}
                >
                  <Icon>visibility</Icon>
                </IconButton>*/}
                <IconButton
                  size="medium"
                  color="primary"
                  aria-controls="notification-menu"
                  aria-haspopup="true"
                  variant="contained"
                  onClick={handleOpenMenu}
                >
                  <Icon>more_vert</Icon>
                </IconButton>
                {renderMenu()}
              </MDBox>
            </Grid>
          </Grid>

          <MDTypography component="div" variant="button" color="text" fontWeight="light">
            {description}
          </MDTypography>

          <Box sx={{ minWidth: 100, width: 100 }}></Box>
        </MDBox>
      </MDBox>
    </Card>
  );
}

// Setting default values for the props of ReportsBarChart
ReportsBarChart.defaultProps = {
  color: "info",
  description: "",
};

// Typechecking props for the ReportsBarChart
ReportsBarChart.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  date: PropTypes.string.isRequired,
  chart: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.array, PropTypes.object])).isRequired,
};

export default ReportsBarChart;
